import favoritesReducer, { favoritesAdapter, favoritesSlice } from './reducer';
import * as selectors from './selectors';

const favoritesActions = {
  ...favoritesSlice.actions,
};

const favoritesSelectors = {
  ...favoritesAdapter.getSelectors(),
  ...selectors,
};

export { favoritesActions, favoritesReducer, favoritesSelectors };
